module.exports = __webpack_public_path__ + "static/media/PlusCircle.0f30e237.svg";